<div style="width: 800px; height: 600px;" data-cy="doctor-warning-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="doctor-warning-dialog-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="doctor-warning-dialog-header">
      <div class="section-header-title" data-cy="doctor-warning-dialog-title">
        Warning
      </div>
      <div style="flex: 1;" data-cy="doctor-warning-dialog-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="doctor-warning-dialog-content">
      <div style="font-size: 14px; color: red; text-align: center;" data-cy="doctor-warning-dialog-message">
        Your save was successful, but be aware of the following:
      </div>
      <div style="margin-top: 16px; text-align: left;" data-cy="doctor-warning-dialog-list-container">
        <ul data-cy="doctor-warning-dialog-list">
          <li *ngIf="isNoLocations" data-cy="doctor-warning-dialog-no-locations">No locations were selected for this doctor.  Selecting a location is useful for selection in the scheduler.</li>
          <li *ngIf="isNoLicenses" data-cy="doctor-warning-dialog-no-licenses">There are no licenses in the system for this doctor.</li>
        </ul>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="doctor-warning-dialog-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="doctor-warning-dialog-footer-spacer"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="doctor-warning-dialog-cancel-btn">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="doctor-warning-dialog-ok-btn">Ok</button>
    </div>
  </div>
</div>
